import { Produkt } from '../model';
import { StatePreV23, StateV23 } from './23_migrate_produkt_breed_label.interface';

const BREED_LABEL_CORRECTIONS: [string, string][] = [
  ['Pyrenäen-Schäferhund Mix', 'Pyrenäenschäferhund Mix'],
  ['Pyrenäen-Schäferhund', 'Pyrenäenschäferhund'],
  ['Berger de Picaderie', 'Berger de Picardie'],
  ['Havanerser', 'Havaneser'],
  ['Rhodesian RIdgeback', 'Rhodesian Ridgeback'],
  ['Rauhhaardackel', 'Rauhaardackel'],
  ['Barbancon', 'Brabancon'],
  ['Jack Russel Terrier', 'Jack Russell Terrier'],
  ['Komodor', 'Komondor'],
  ['Labardor Retriever', 'Labrador Retriever'],
  ['Parson Russel Terrier', 'Parson Russell Terrier'],
  ['Fox Terrier (Glatthaar)', 'Foxterrier (Glatthaar)'],
];

const correctBreedLabels = (versichertesRisiko: string): string => {
  if (!versichertesRisiko) {
    return versichertesRisiko;
  }
  return BREED_LABEL_CORRECTIONS.reduce(
    (result, [oldLabel, newLabel]) => result.split(oldLabel).join(newLabel),
    versichertesRisiko,
  );
};

export const migrateProduktBreedLabel = (
  previousState: StatePreV23,
  newVersion: number,
): StateV23 => {
  const migratedProdukte = previousState.produkte?.map(produkt => ({
    ...produkt,
    versichertesRisiko: correctBreedLabels(produkt.versichertesRisiko),
  })) as Produkt[];

  return {
    ...previousState,
    version: newVersion,
    produkte: migratedProdukte,
  };
};
